//#region shopify-cat-id/src/pixel-film.ts
var e = 1.56, t = .38, n = "#f67b22", r = "#292724", i = "#f9f6f3", a = (e) => Math.max(0, Math.min(1, e)), o = (e, t, n) => e + (t - e) * n, s = (e, t, n) => {
	let r = a((e - t) / (n - t));
	return r * r * (3 - 2 * r);
}, c = (e, t) => ({
	x: e.x - t.x,
	y: e.y - t.y,
	z: e.z - t.z
}), l = (e, t) => e.x * t.x + e.y * t.y + e.z * t.z, u = (e, t) => ({
	x: e.y * t.z - e.z * t.y,
	y: e.z * t.x - e.x * t.z,
	z: e.x * t.y - e.y * t.x
}), d = (e) => {
	let t = Math.hypot(e.x, e.y, e.z);
	return {
		x: e.x / t,
		y: e.y / t,
		z: e.z / t
	};
};
function f(e, t, n, r, i, a = !1, o = !1) {
	let [s, c, l, u] = a ? [
		[
			30,
			110,
			500,
			800
		],
		[
			535,
			110,
			510,
			800
		],
		[
			1080,
			235,
			400,
			580
		]
	][t] : [
		t * Math.floor(e.width / r),
		n * Math.floor(e.height / i),
		Math.floor(e.width / r),
		Math.floor(e.height / i)
	], d = document.createElement("canvas");
	d.width = l, d.height = u;
	let f = d.getContext("2d");
	f.drawImage(e, s, c, l, u, 0, 0, l, u);
	let p = f.getImageData(0, 0, l, u), m = p.data, h = new Uint8Array(l * u), g = new Int32Array(l * u), _ = 0, v = 0, y = (e) => {
		let t = m[e * 4], n = m[e * 4 + 1], r = m[e * 4 + 2];
		return o ? t - n > 30 && r - n > 30 : Math.min(t, n, r) > (a ? 85 : 150) && Math.max(t, n, r) - Math.min(t, n, r) < (a ? 10 : 6);
	};
	if (o) for (let e = 0; e < l * u; e++) y(e) && (m[e * 4 + 3] = 0);
	let b = (e) => {
		e < 0 || e >= h.length || h[e] || !y(e) || (h[e] = 1, g[v++] = e);
	};
	for (let e = 0; e < l; e++) b(e), b((u - 1) * l + e);
	for (let e = 0; e < u; e++) b(e * l), b(e * l + l - 1);
	for (a && b(Math.floor(u * .5) * l + Math.floor(l * .5)); _ < v;) {
		let e = g[_++];
		m[e * 4 + 3] = 0;
		let t = e % l;
		t > 0 && b(e - 1), t < l - 1 && b(e + 1), b(e - l), b(e + l);
	}
	let x = new Int32Array(l * u), S = 0, C = 0, w = 0;
	for (let e = 0; e < x.length; e++) if (!(x[e] || m[e * 4 + 3] < 96)) {
		for (S++, _ = 0, v = 1, g[0] = e, x[e] = S; _ < v;) {
			let e = g[_++], t = e % l;
			for (let n of [
				t ? e - 1 : -1,
				t < l - 1 ? e + 1 : -1,
				e - l,
				e + l
			]) n >= 0 && n < x.length && !x[n] && m[n * 4 + 3] >= 96 && (x[n] = S, g[v++] = n);
		}
		v > w && (w = v, C = S);
	}
	for (let e = 0; e < x.length; e++) x[e] !== C && (m[e * 4 + 3] = 0);
	f.putImageData(p, 0, 0);
	let T = l, E = 0, D = u, O = 0;
	for (let e = 0; e < u; e++) for (let t = 0; t < l; t++) m[(e * l + t) * 4 + 3] > 96 && (T = Math.min(T, t), E = Math.max(E, t), D = Math.min(D, e), O = Math.max(O, e));
	if (E <= T || O <= D) throw Error("Empty sprite cell");
	let k = document.createElement("canvas");
	return k.width = E - T + 1, k.height = O - D + 1, k.getContext("2d").drawImage(d, T, D, k.width, k.height, 0, 0, k.width, k.height), {
		image: k,
		w: k.width,
		h: k.height
	};
}
async function p(e) {
	let t = await fetch(e);
	if (!t.ok || !t.headers.get("content-type")?.startsWith("image/")) throw Error(e);
	return createImageBitmap(await t.blob());
}
async function m(m, h) {
	let [g, _, v] = await Promise.all([
		p(h.cat),
		p(h.product),
		p(h.closeups)
	]), y = Array.from({ length: 12 }, (e, t) => f(g, t % 4, Math.floor(t / 4), 4, 3));
	for (let [e, t] of [[5, 0], [11, 1]]) y[e].image.width = 0, y[e] = f(v, t, 0, 2, 1, !1, !0);
	let b = Array.from({ length: 3 }, (e, t) => f(_, t, 0, 3, 1, !0));
	g.close(), _.close(), v.close(), m.width = 1440, m.height = 900;
	let x = m.getContext("2d", { alpha: !1 });
	x.imageSmoothingEnabled = !1;
	let S, C, w, T, E = (e) => {
		let t = c(e, S), n = Math.max(.1, l(t, C));
		return {
			x: 480 * .54 + l(t, w) * 340 / n,
			y: 156 - l(t, T) * 340 / n,
			depth: n
		};
	};
	function D(e, t, n, r, i, a, o) {
		let [s, c] = i, [l, u] = a, [d, f] = o, p = s * (u - f) + l * (f - c) + d * (c - u);
		if (Math.abs(p) < .001) return;
		let m = (e, t, n) => [
			(e * (u - f) + t * (f - c) + n * (c - u)) / p,
			(e * (d - l) + t * (s - d) + n * (l - s)) / p,
			(e * (l * f - d * u) + t * (d * c - s * f) + n * (s * u - l * c)) / p
		], h = m(t.x, n.x, r.x), g = m(t.y, n.y, r.y);
		x.save(), x.beginPath(), x.moveTo(t.x, t.y), x.lineTo(n.x, n.y), x.lineTo(r.x, r.y), x.closePath(), x.clip(), x.transform(h[0], g[0], h[1], g[1], h[2], g[2]), x.drawImage(e, 0, 0), x.restore();
	}
	function O(e, t) {
		for (let n = 0; n < 8; n++) for (let r = 0; r < 8; r++) {
			let i = r / 8, a = n / 8, o = (r + 1) / 8, s = (n + 1) / 8, c = E(t(i, a)), l = E(t(o, a)), u = E(t(o, s)), d = E(t(i, s));
			D(e.image, c, l, u, [i * e.w, a * e.h], [o * e.w, a * e.h], [o * e.w, s * e.h]), D(e.image, c, u, d, [i * e.w, a * e.h], [o * e.w, s * e.h], [i * e.w, s * e.h]);
		}
	}
	function k(e, t, n, r = 1) {
		x.strokeStyle = n, x.lineWidth = r, x.beginPath(), x.moveTo(Math.round(e.x), Math.round(e.y)), x.lineTo(Math.round(t.x), Math.round(t.y)), x.stroke();
	}
	function A(e, t, n, r, i) {
		x.fillStyle = i, x.fillRect(Math.round(e), Math.round(t), Math.round(n), Math.round(r));
	}
	function j(e, t, n, r = 0) {
		let i = y[e], a = E({
			...t,
			y: t.y + r
		}), o = E({
			...t,
			y: t.y + r + n
		}), s = Math.abs(a.y - o.y), c = s * i.w / i.h, l = a.x - c / 2, u = o.y;
		return x.drawImage(i.image, l, u, c, s), {
			x: l,
			y: u,
			w: c,
			h: s
		};
	}
	function M(e, t) {
		let n = E(e);
		x.fillStyle = "#d8cfc256", x.beginPath(), x.ellipse(Math.round(n.x), Math.round(n.y), 340 / n.depth * t, 340 / n.depth * .065, 0, 0, Math.PI * 2), x.fill();
	}
	function N(e, t, n, r) {
		x.save(), x.beginPath(), x.rect(t, n, r, r), x.clip();
		let i = e.w, a = e.h * .52, o = r / Math.max(i, a);
		x.drawImage(e.image, 0, e.h * .15, i, a, t + (r - i * o) / 2, n + (r - a * o) / 2, i * o, a * o), x.restore();
	}
	function P(e, t) {
		let o = {}, c = s(e, .3, .35), l = 1 - s(e, .535, .56), u = s(e, .545, .585), d = 1 - s(e, .685, .735), f = t.x + t.w * .53, p = t.y + t.h * .43, m = t.w * .76, h = t.h * .4, g = f - m / 2, _ = p - h / 2;
		if (c * l > 0) {
			x.save(), x.globalAlpha = c * l;
			let t = g - 8, r = _ - 8, u = g + m + 8, d = _ + h + 8;
			for (let [e, i, a, o] of [
				[
					t,
					r,
					1,
					1
				],
				[
					u,
					r,
					-1,
					1
				],
				[
					t,
					d,
					1,
					-1
				],
				[
					u,
					d,
					-1,
					-1
				]
			]) A(e + (a < 0 ? -12 : 0), i, 12, 3, n), A(e, i + (o < 0 ? -12 : 0), 3, 12, n);
			let p = [
				[.18, .22],
				[.5, .1],
				[.82, .22],
				[.15, .5],
				[.5, .47],
				[.85, .5],
				[.25, .76],
				[.5, .86],
				[.75, .76]
			].map(([e, t]) => ({
				x: g + e * m,
				y: _ + t * h,
				depth: 1
			})), v = [
				[0, 1],
				[1, 2],
				[0, 3],
				[1, 4],
				[2, 5],
				[3, 4],
				[4, 5],
				[3, 6],
				[4, 6],
				[4, 7],
				[4, 8],
				[5, 8],
				[6, 7],
				[7, 8],
				[0, 4],
				[2, 4]
			], y = s(e, .33, .42);
			for (let e = 0; e < v.length * y; e++) {
				let [t, r] = v[e];
				k(p[t], p[r], "#fff8ed", 3), k(p[t], p[r], n, 1);
			}
			for (let e = 0; e < p.length * y; e++) {
				let t = p[e];
				A(t.x - 3, t.y - 3, 7, 7, n), A(t.x - 1, t.y - 1, 3, 3, i);
			}
			let b = _ + h * (a((e - .32) / .215) * 2 % 1);
			x.globalAlpha *= .22, A(g - 12, b - 5, m + 24, 11, n), x.globalAlpha = c * l, A(g - 12, b, m + 24, 2, n), o.scan = {
				x: f / 480 * 100,
				y: Math.min(284, _ + h + 22) / 300 * 100,
				opacity: c * l
			}, x.restore();
		}
		if (u * d > 0) {
			x.save(), x.globalAlpha = u * d;
			let t = Math.min(398, g + m + 30), a = _ + 12, c = g + m + 4;
			x.setLineDash([3, 3]), k({
				x: c,
				y: p,
				depth: 1
			}, {
				x: t - 3,
				y: p,
				depth: 1
			}, n, 2), x.setLineDash([]), A(t - 4, a - 4, 72, 72, r), A(t - 2, a - 2, 68, 68, i), N(y[5], t + 3, a + 3, 58);
			let l = s(e, .58, .61);
			if (A(t + 64 - 16, a + 64 - 16, 31, 31, n), l > .1) {
				let e = {
					x: t + 64 - 10,
					y: a + 64 - 1,
					depth: 1
				}, n = {
					x: t + 64 - 3,
					y: a + 64 + 6,
					depth: 1
				}, i = {
					x: t + 64 + 10,
					y: a + 64 - 8,
					depth: 1
				};
				k(e, n, r, 4), l > .5 && k(n, i, r, 4);
			}
			o.match = {
				x: (t + 32) / 480 * 100,
				y: (a + 64 + 22) / 300 * 100,
				opacity: u * d
			}, x.restore();
		}
		return o;
	}
	let F = (() => {
		let e = b[0], t = e.image.getContext("2d").getImageData(0, 0, e.w, e.h).data, n = (n, r) => t[(r * e.w + n) * 4 + 3] > 96, r = [], i = [], a = [], o = [];
		for (let t = 0; t < e.h; t += Math.max(1, Math.floor(e.h / 100))) {
			let s = 0, c = e.w - 1;
			for (; s < c && !n(s, t);) s++;
			for (; c > s && !n(c, t);) c--;
			if (c <= s) continue;
			r.push([s / e.w, t / e.h]), i.push([c / e.w, t / e.h]);
			let l = Math.floor(e.w / 2);
			if (t > e.h * .16 && t < e.h * .84 && !n(l, t)) {
				let r = l, i = l;
				for (; r > s && !n(r, t);) r--;
				for (; i < c && !n(i, t);) i++;
				a.push([r / e.w, t / e.h]), o.push([i / e.w, t / e.h]);
			}
		}
		return [[...r, ...i.reverse()], [...a, ...o.reverse()]];
	})();
	function I() {
		let n = [];
		for (let [r, i] of F.entries()) for (let a = 0; a < i.length; a++) {
			let o = i[a], s = i[(a + 1) % i.length], c = (t, n) => ({
				x: (2 * t[0] - 1) * e,
				y: (1 - t[1]) * 3.95,
				z: n
			}), l = [
				E(c(o, -.38)),
				E(c(s, -.38)),
				E(c(s, t)),
				E(c(o, t))
			], u = Math.abs(s[1] - o[1]) > Math.abs(s[0] - o[0]);
			n.push({
				q: l,
				shade: r ? "#c7c0b5" : u ? "#ded8ce" : "#ece8e1"
			});
		}
		n.sort((e, t) => t.q.reduce((e, t) => e + t.depth, 0) - e.q.reduce((e, t) => e + t.depth, 0));
		for (let { q: e, shade: t } of n) x.beginPath(), e.forEach((e, t) => t ? x.lineTo(e.x, e.y) : x.moveTo(e.x, e.y)), x.closePath(), x.fillStyle = t, x.fill(), x.strokeStyle = t, x.lineWidth = .35, x.stroke();
	}
	return {
		draw: (n) => {
			n = a(n), x.setTransform(3, 0, 0, 3, 0, 0), x.globalAlpha = 1, x.imageSmoothingEnabled = !1, x.fillStyle = i, x.fillRect(0, 0, 480, 300);
			let r = s(n, .03, .235), l = s(n, .22, .34), f = s(n, .68, .82), p = s(n, .8, .955), h = s(n, .7, .88), g = o(-.2, Math.PI - .13, h), _ = {
				x: o(-.45, -.38, l) * (1 - f),
				y: o(1.9, 1.32, l) * (1 - f) + 1.95 * f,
				z: o(0, -1.38, l) * (1 - f)
			}, v = o(o(7.8, 3.05, l), 8.3, f);
			S = {
				x: _.x + Math.sin(g) * v,
				y: _.y + o(1, .2, l) * (1 - f) + .8 * f,
				z: _.z - Math.cos(g) * v
			}, C = d(c(_, S)), w = d(u({
				x: 0,
				y: 1,
				z: 0
			}, C)), T = u(C, w);
			let y = {
				x: o(-2.75, -.38, r) * (1 - p),
				y: Math.sin(p * Math.PI) * .65,
				z: o(-1.38, 1.95, p)
			};
			M({
				x: 0,
				y: 0,
				z: 0
			}, 1.6), M(y, .65);
			let D = S.z > 0, A = D ? t : -.38, N = 0;
			N = n < .225 ? Math.floor(r * 24) % 4 : n < .27 ? 4 : n < .71 ? 5 : n < .745 ? 8 : n < .8 ? 9 : n < .835 ? 10 : n < .865 ? 4 : n > .945 ? 11 : 5;
			let F = n < .235 ? Math.sin(r * Math.PI * 24) * .027 : n > .8 ? Math.sin(p * Math.PI * 16) * .025 : 0, L = {
				x: 0,
				y: 0,
				w: 0,
				h: 0
			}, R = () => {
				L = j(N, y, 2.42, F);
			}, z = () => {
				I();
				let t = b[+!!D];
				O(t, (t, n) => ({
					x: (D ? 1 - 2 * t : 2 * t - 1) * e,
					y: (1 - n) * 3.95,
					z: A
				}));
			}, B = () => {
				let e = 1.1 * s(n, .775, .825) * (1 - s(n, .958, 1)), t = (t, n) => E({
					x: (2 * t - 1) * 1.07,
					y: 3.04 - n * 2.34 * Math.cos(e),
					z: .02 + n * 2.34 * Math.sin(e)
				}), r = [
					t(0, 0),
					t(1, 0),
					t(1, 1),
					t(0, 1)
				];
				x.save(), x.beginPath(), r.forEach((e, t) => t ? x.lineTo(e.x, e.y) : x.moveTo(e.x, e.y)), x.closePath(), x.fillStyle = "#d4d0c325", x.fill(), x.strokeStyle = "#b9b3a8", x.lineWidth = 1, x.stroke(), x.clip(), k(t(.06, .3), t(.37, .03), "#ffffff95", 3), k(t(.68, .97), t(.97, .67), "#ffffff75", 2), x.restore();
			}, V = D ? y.z > A : y.z < A;
			V || R(), z(), B(), V && R();
			let H = n >= .3 && n < .74 ? P(n, L) : {};
			return m.dataset.phase = n < .3 ? "approach" : n < .545 ? "scan" : n < .735 ? "recognized" : "home", m.dataset.productSide = D ? "inside-four-buttons" : "outside-cameras", m.dataset.sprite = String(N), H;
		},
		dispose: () => {
			for (let e of [...y, ...b]) e.image.width = 0, e.image.height = 0;
		}
	};
}
//#endregion
//#region shopify-cat-id/src/pixel-player.ts
function h(e) {
	let { canvas: t, spacer: n, setProgress: r, setReady: i, setPlaying: a, setReduced: o, setError: s, control: c } = e, l = matchMedia("(prefers-reduced-motion: reduce)"), u = (e) => Math.max(0, Math.min(1, e)), d, f = !0, p = 0, m = 0, h = 0, g = 0, _ = 0, v = !1, y = 0, b = 0, x = -1;
	o(l.matches);
	let S = () => Math.max(1, n.offsetHeight - innerHeight), C = () => {
		v = !1, a(!1);
	}, w = () => {
		d && e.setOverlay(d.draw(g)), t.dataset.frame = String(1 + Math.round(g * 959));
		let n = Math.round(g * 2e3);
		n !== x && (x = n, r(g));
	}, T = (e) => {
		if (!f) return;
		let t = Math.min(50, m ? e - m : 16.667);
		m = e, v && (h = u(b + (e - y) / 16e3), scrollTo({
			top: n.getBoundingClientRect().top + scrollY + h * S(),
			behavior: "instant"
		}), h === 1 && C());
		let r = h - g;
		g = l.matches || Math.abs(r) < 3e-5 ? h : g + r * (1 - Math.exp(-t / 65)), w(), v || g !== h ? p = requestAnimationFrame(T) : (p = 0, m = 0);
	}, E = () => {
		p ||= requestAnimationFrame(T);
	}, D = () => {
		h = l.matches ? _ : u((scrollY - (n.getBoundingClientRect().top + scrollY)) / S()), E();
	};
	c.current = {
		jump: (e) => {
			if (C(), e = u(e), e === 0) {
				_ = h = g = 0, scrollTo({
					top: n.getBoundingClientRect().top + scrollY,
					behavior: "instant"
				}), w();
				return;
			}
			if (l.matches) {
				_ = h = g = e, w(), n.scrollIntoView({ behavior: "instant" });
				return;
			}
			scrollTo({
				top: n.getBoundingClientRect().top + scrollY + e * S(),
				behavior: "smooth"
			});
		},
		toggle: () => {
			if (v) {
				C();
				return;
			}
			!l.matches && d && (b = g > .98 ? 0 : g, b === 0 && (g = h = 0, w()), v = !0, y = performance.now(), a(!0), E());
		}
	};
	let O = (e) => {
		e.key !== "Escape" && e.target instanceof Element && e.target.closest("button,a,input") || [
			"Escape",
			"ArrowDown",
			"ArrowUp",
			"PageDown",
			"PageUp",
			"Home",
			"End",
			" "
		].includes(e.key) && C();
	}, k = () => {
		C(), _ = g, o(l.matches), D();
	}, A = () => {
		document.hidden && C();
	};
	return addEventListener("scroll", D, { passive: !0 }), addEventListener("resize", D), addEventListener("wheel", C, { passive: !0 }), addEventListener("touchstart", C, { passive: !0 }), addEventListener("keydown", O), l.addEventListener("change", k), document.addEventListener("visibilitychange", A), e.createFilm(t).then((e) => {
		if (!f) {
			e.dispose();
			return;
		}
		d = e, w(), i(!0), E();
	}).catch(() => {
		f && s("Die Animation konnte nicht geladen werden. Bitte lade die Seite neu.");
	}), D(), () => {
		f = !1, cancelAnimationFrame(p), d?.dispose(), removeEventListener("scroll", D), removeEventListener("resize", D), removeEventListener("wheel", C), removeEventListener("touchstart", C), removeEventListener("keydown", O), l.removeEventListener("change", k), document.removeEventListener("visibilitychange", A);
	};
}
//#endregion
//#region shopify-cat-id/src/flappie-cat-id.ts
var g = /* @__PURE__ */ new WeakMap(), _ = (e, t) => e.querySelector(t), v = (e, t) => Array.from(e.querySelectorAll(t)), y = (e) => Math.max(0, Math.min(1, e));
function b(e) {
	if (g.has(e)) return;
	let t = new AbortController(), n = [], r = t.signal, i = (e, t, n, i = {}) => e.addEventListener(t, n, {
		signal: r,
		...i
	}), a = (t) => Array.from(_(e, t).content.children).map((e) => e.textContent || ""), o = matchMedia("(prefers-reduced-motion:reduce)");
	e.classList.add("is-enhanced");
	let s = new IntersectionObserver((e) => e.forEach((e) => {
		e.isIntersecting && (e.target.classList.add("sc-in"), s.unobserve(e.target));
	}), { threshold: .08 });
	if (v(e, "[data-reveal]").forEach((e) => s.observe(e)), n.push(() => s.disconnect()), e.dataset.catIdSection === "hero") {
		let t = _(e, ".fsh-root"), r = _(e, ".fsh-canvas"), a = _(e, ".fsh-spacer"), o = _(e, ".fsh-poster"), s = _(e, ".fsh-copy"), c = _(e, ".fsh-canvas-wrap"), l = _(e, ".fsh-stage"), u = 0, d = () => {
			u = 0, l.style.setProperty("--cat-id-flow-top", Math.max(0, a.getBoundingClientRect().top) + "px"), l.style.setProperty("--cat-id-copy-height", s.offsetHeight + "px");
		}, f = () => {
			u ||= requestAnimationFrame(d);
		}, p = new ResizeObserver(f);
		p.observe(s), document.querySelectorAll(".shopify-section-group-header-group").forEach((e) => p.observe(e)), i(window, "scroll", f, { passive: !0 }), i(window, "resize", f), n.push(() => {
			p.disconnect(), cancelAnimationFrame(u);
		}), d();
		let g = v(e, ".fsh-card"), b = v(e, ".fsh-chapters button"), x = _(e, ".fsh-bottom p"), S = x.textContent, C = _(e, ".play"), w = _(e, ".fsh-loading"), T = ["scan", "match"].map((t) => _(e, ".film-label-" + t)), E = { current: {
			jump: (e) => {},
			toggle: () => {}
		} }, D = -1, O = [
			[.12, .3],
			[.3, .545],
			[.545, .735],
			[.735, 1.01]
		], k = h({
			canvas: r,
			spacer: a,
			control: E,
			createFilm: (e) => m(e, {
				cat: t.dataset.catAtlas,
				product: t.dataset.productAtlas,
				closeups: t.dataset.closeups
			}),
			setProgress: (e) => {
				let t = O.findIndex(([t, n]) => e >= t && e < n);
				c.style.setProperty("--intro", String(1 - y(e / .2))), s.style.opacity = String(1 - y(e / .15)), s.style.transform = `translateY(${-y(e / .18) * 25}px)`, s.setAttribute("aria-hidden", String(e > .15)), t !== D && (D = t, g.forEach((e, t) => {
					e.classList.toggle("fsh-card-active", t === D), e.classList.toggle("fsh-card-prev", D > t), e.setAttribute("aria-hidden", String(t !== D));
				}), x.textContent = D >= 0 ? _(g[D], ".fsh-card-label").textContent : S, b.forEach((e, t) => {
					t === D ? e.setAttribute("aria-current", "step") : e.removeAttribute("aria-current");
				})), x.textContent = e > .65 && e < .75 ? _(g[2], "h2").textContent : D >= 0 ? _(g[D], ".fsh-card-label").textContent : S, b.forEach((t, n) => _(t, "b").style.transform = `scaleX(${y((e - O[n][0]) / (O[n][1] - O[n][0]))})`);
			},
			setOverlay: (e) => {
				[e.scan, e.match].forEach((e, t) => {
					T[t].hidden = !e, e && (T[t].style.left = e.x + "%", T[t].style.top = e.y + "%", T[t].style.opacity = String(e.opacity));
				});
			},
			setReady: (e) => {
				r.style.opacity = e ? "1" : "0", o.hidden = e, w.hidden = e, C.disabled = !e;
			},
			setPlaying: (t) => {
				C.setAttribute("aria-pressed", String(t)), C.setAttribute("aria-label", t ? e.dataset.pauseAnimation : e.dataset.playAnimation), _(C, "span").textContent = t ? e.dataset.pause : e.dataset.play, _(C, "svg").innerHTML = t ? "<path d=\"M10 4H6v16h4zM18 4h-4v16h4z\"/>" : "<path d=\"m6 3 14 9-14 9z\"/>";
			},
			setReduced: (n) => {
				e.classList.toggle("motion-reduced", n), t.classList.toggle("motion-reduced", n), C.hidden = n;
			},
			setError: () => {
				w.textContent = e.dataset.animationError, w.hidden = !1, e.classList.remove("is-enhanced"), o.hidden = !1;
			}
		});
		n.push(k), b.forEach((e, t) => i(e, "click", () => E.current.jump((O[t][0] + O[t][1]) / 2))), i(_(e, ".playback button"), "click", () => E.current.jump(0)), i(C, "click", () => E.current.toggle());
	}
	if (e.dataset.catIdSection === "recognition") {
		let t = _(e, ".recognition-visual"), r = _(e, ".cat-portrait img"), s = {
			src: r.src,
			alt: r.alt
		}, c = _(e, "template[data-art]").content.querySelectorAll("img"), l = v(e, ".scenario-switch button"), u = v(e, ".technology-step"), d = _(e, ".recognition-status>span:last-child"), f = a("template[data-recognition-copy]"), p = 0, m = !0, h = 0, g = (n = p) => {
			p = n, t.className = `recognition-visual phase-${p} ${m ? "is-known" : "is-unknown"}`, t.dataset.scVerifyState = `${p}-${m ? "known" : "unknown"}`;
			let i = m ? p === 3 ? c[1] : s : c[0];
			r.src = i.src, r.alt = i.alt, d.textContent = f[p < 2 ? p : p === 2 ? m ? 2 : 3 : m ? 4 : 5], u.forEach((e, t) => {
				e.classList.toggle("is-active", t === p), e.setAttribute("aria-pressed", String(t === p));
			}), l.forEach((e, t) => e.setAttribute("aria-pressed", String(t === 0 ? m : !m))), _(e, ".match-tile").setAttribute("aria-hidden", String(p !== 2)), _(e, ".saved-face>svg").innerHTML = m ? "<path d=\"m20 6-11 11-5-5\"/>" : "<path d=\"m18 6-12 12M6 6l12 12\"/>", _(e, ".entry-symbol>svg").innerHTML = m ? "<path d=\"M18 21h2a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-2M3 21h18M3 21V5l12-2v18M10 12h.01\"/>" : "<path d=\"M18 21V3H6v18M3 21h18M14 12h.01\"/>";
		};
		l.forEach((e, t) => i(e, "click", () => {
			m = t === 0, g();
		})), u.forEach((e, t) => i(e, "click", () => g(t)));
		let y = () => {
			if (h = 0, o.matches) return;
			let e = t.getBoundingClientRect();
			if (e.bottom < 0 || e.top > innerHeight) return;
			let n = Infinity, r = p, i = innerHeight * (innerWidth < 760 ? .8 : .54);
			u.forEach((e, t) => {
				let a = e.getBoundingClientRect(), o = Math.abs(a.top + a.height / 2 - i);
				o < n && (n = o, r = t);
			}), r !== p && g(r);
		};
		i(window, "scroll", () => {
			h ||= requestAnimationFrame(y);
		}, { passive: !0 }), i(window, "resize", y), n.push(() => cancelAnimationFrame(h)), g();
	}
	if (e.dataset.catIdSection === "protection") {
		let t = a("template[data-protection-copy]"), n = v(e, ".protection-selector button");
		n.forEach((r, a) => i(r, "click", () => {
			n.forEach((e, t) => e.setAttribute("aria-pressed", String(a === t)));
			let r = _(e, ".protection-image");
			r.classList.toggle("check-prey", a === 1), r.setAttribute("aria-label", t[4 + a]), _(e, ".inspection-label").textContent = t[a], _(e, ".protection-text h3").textContent = t[2 + a], _(e, ".protection-text p").textContent = t[4 + a];
		}));
	}
	if (e.dataset.catIdSection === "setup") {
		let t = v(e, "[role=tab]"), n = v(e, "[data-setup-panel]"), r = 0, o = !1, s = (e, i = !1) => {
			r = e, t.forEach((t, n) => {
				t.setAttribute("aria-selected", String(e === n)), t.tabIndex = e === n ? 0 : -1;
			}), n.forEach((t, n) => t.hidden = e !== n), i && t[e].focus();
		};
		t.forEach((e, t) => i(e, "click", () => s(t))), i(_(e, ".setup-tabs"), "keydown", ((e) => {
			[
				"ArrowRight",
				"ArrowLeft",
				"Home",
				"End"
			].includes(e.key) && (e.preventDefault(), s(e.key === "Home" ? 0 : e.key === "End" ? 2 : (r + (e.key === "ArrowRight" ? 1 : 2)) % 3, !0));
		})), n.forEach((e, t) => {
			let n = e.querySelector(".text-button");
			n && i(n, "click", () => s(t + 1, !0));
		}), s(0);
		let c = _(e, ".assignment"), l = _(c, "button"), u = _(c, "img"), d = u.src, f = a("template[data-assignment-copy]"), p = _(e, "template[data-assignment-copy]").content.querySelector("img");
		i(l, "click", () => {
			o = !o, c.classList.toggle("assigned", o), l.setAttribute("aria-pressed", String(o)), l.lastChild.textContent = " " + f[+!!o], _(l, "svg").innerHTML = o ? "<path d=\"m20 6-11 11-5-5\"/>" : "<path d=\"M12 5v14M5 12h14\"/>", u.src = o ? p.src : d;
		});
	}
	if (e.dataset.catIdSection === "launch") {
		let t = _(e, ".launch-film"), r = _(e, ".film-frame"), o = _(e, ".film-cover"), s = _(e, "figcaption"), c = r.querySelector("video"), l = a("template[data-film-copy]"), u = s.innerHTML;
		if (c) {
			let e = 0, a;
			c.controls = !1, c.setAttribute("aria-label", l[0]), c.tabIndex = 0;
			let d = () => {
				clearTimeout(e), a?.remove(), a = void 0;
			}, f = () => d(), p = Array.from(c.querySelectorAll("source")).find((e) => e.type === "video/mp4")?.src || c.getAttribute("src") || "", m = () => {
				let e = document.createElement("a");
				return e.href = p, e.target = "_blank", e.rel = "noopener noreferrer", e.textContent = l[3], e;
			}, h = (e) => {
				a && (a.classList.add("is-slow"), _(a, "p").textContent = e, a.querySelector("a") || _(a, "div").append(m()));
			}, g = () => {
				d(), c.pause(), c.controls = !1, c.load(), t.classList.remove("is-playing"), s.innerHTML = u, o.focus();
			};
			i(c, "playing", f), i(c, "canplay", f), i(c, "error", () => {
				clearTimeout(e), h(l[5]);
			}), i(o, "click", () => {
				d(), t.classList.add("is-playing"), c.controls = !0, a = document.createElement("div"), a.className = "film-loading";
				let n = document.createElement("div"), i = document.createElement("p");
				i.setAttribute("role", "status"), i.textContent = l[1], n.append(i), a.append(n), r.append(a);
				let o = document.createElement("span");
				o.className = "film-actions";
				let u = document.createElement("button");
				u.type = "button", u.setAttribute("aria-label", l[4]), u.textContent = "×", o.append(m(), u), s.lastElementChild?.replaceWith(o), u.addEventListener("click", g, { once: !0 }), e = window.setTimeout(() => h(l[2]), 1e4), c.focus(), c.play().catch(() => {
					c.error || f();
				});
			}), n.push(() => {
				d(), c.pause(), c.preload = "none", c.load();
			});
		}
	}
	if (i(e, "click", ((e) => {
		let t = e.target instanceof Element ? e.target.closest("button,a") : null;
		t && (t.matches(".invitation-actions button,.labs-note button,.setup-copy .landing-cta") && document.querySelector(".flappie-cat-id .activation-dialog")?.showModal(), t.matches(".dialog-close,.activation-dialog>.landing-cta") && t.closest("dialog")?.close(), t.matches("a[href=\"#faq-8\"]") && document.querySelector(".flappie-cat-id #faq-8")?.setAttribute("open", ""));
	})), e.dataset.catIdSection === "activation") {
		let t = _(e, "dialog");
		i(t, "click", ((e) => {
			if (e.target !== t) return;
			let n = t.getBoundingClientRect();
			(e.clientX < n.left || e.clientX > n.right || e.clientY < n.top || e.clientY > n.bottom) && t.close();
		})), n.push(() => t.close());
	}
	g.set(e, () => {
		t.abort(), n.forEach((e) => e()), e.classList.remove("is-enhanced"), g.delete(e);
	});
}
function x(e = document) {
	v(e, "[data-cat-id-section]").forEach(b);
}
x(), document.addEventListener("shopify:section:load", (e) => x(e.target)), document.addEventListener("shopify:section:unload", (e) => v(e.target, "[data-cat-id-section]").forEach((e) => g.get(e)?.())), document.addEventListener("shopify:block:select", (e) => {
	let t = e.target.closest("details");
	t && (t.open = !0);
});
//#endregion
